'use strict';

exports.__esModule = true;
exports.list = list;
exports.fetchEta = fetchEta;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _estimatesClient = require('../network/estimates-client');

var _estimatesClient2 = _interopRequireDefault(_estimatesClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  PARTNER_ADDRESS: '/partner/addresses'

  /**
   * Wrapper for `/partner/addresses` API endpoint
   */
};var addresses = {
  list: list,
  fetchEta: fetchEta
};

exports.default = addresses;

/**
 * Get all addresses
 * @param {Object} address - Address model.
 * @returns {promise} containing the entity array of addresses
 */

function list() {
  return _apiClient2.default.get({ route: API.PARTNER_ADDRESS });
}

/**
 * Gets estimated ETA time from generate match
 * @param {number} longpoint
 * @param {number} latpoint
 */

function fetchEta(lon, lat, slug) {
  return _estimatesClient2.default.get({
    route: '/eaq_minutes',
    params: { lon: lon, lat: lat, slug: slug }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/addresses.js
// module id = 1069
// module chunks = 0